import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import defaultTo from 'lodash/defaultTo';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { allValidators, extendPropTypes } from '../utils/propTypes';
import InputWithOptions from '../InputWithOptions';
import { st, classes } from './Dropdown.st.css';
import PropTypes from 'prop-types';
var NO_SELECTED_ID = null;

var Dropdown = /*#__PURE__*/function (_InputWithOptions) {
  _inherits(Dropdown, _InputWithOptions);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);
    _this.state = _objectSpread({
      value: '',
      selectedId: NO_SELECTED_ID
    }, Dropdown.getNextState(props, defaultTo(props.selectedId, props.initialSelectedId)));
    return _this;
  }

  _createClass(Dropdown, [{
    key: "isSelectedIdControlled",
    value: function isSelectedIdControlled() {
      return typeof this.props.selectedId !== 'undefined';
    }
  }, {
    key: "getSelectedId",
    value: function getSelectedId() {
      return this.isSelectedIdControlled() ? this.props.selectedId : this.state.selectedId;
    }
  }, {
    key: "_onInputClicked",
    value: function _onInputClicked(event) {
      if (this.state.showOptions && Date.now() - this.state.lastOptionsShow > 200) {
        this.hideOptions();
      } else {
        this.showOptions();
      }

      if (this.props.onInputClicked) {
        this.props.onInputClicked(event);
      }
    }
    /**
     * Updates the value by the selectedId.
     * If selectedId is not found in options, then value is NOT changed.
     */

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.selectedId !== this.props.selectedId || !Dropdown.isOptionsEqual(this.props.options, nextProps.options)) {
        this.setState(Dropdown.getNextState(nextProps, nextProps.selectedId, this.state.selectedId));
      }
    }
  }, {
    key: "inputClasses",
    value: function inputClasses() {
      var noBorder = this.props.noBorder;
      return st(classes.showPointer, {
        noBorder: noBorder
      });
    }
  }, {
    key: "dropdownAdditionalProps",
    value: function dropdownAdditionalProps() {
      return {
        selectedId: this.getSelectedId(),
        value: this.state.value,
        tabIndex: -1,
        withArrow: false
      };
    }
  }, {
    key: "inputAdditionalProps",
    value: function inputAdditionalProps() {
      return {
        readOnly: false,
        disableEditing: true,
        value: this.state.value
      };
    }
  }, {
    key: "_onSelect",
    value: function _onSelect(option) {
      if (!this.isSelectedIdControlled()) {
        this.setState({
          value: this.props.valueParser(option),
          selectedId: option.id
        });
      }

      _get(_getPrototypeOf(Dropdown.prototype), "_onSelect", this).call(this, option);
    }
  }, {
    key: "_onChange",
    value: function _onChange(event) {
      this.setState({
        value: event.target.value
      });

      _get(_getPrototypeOf(Dropdown.prototype), "_onChange", this).call(this, event);
    }
  }], [{
    key: "isOptionsEqual",
    value: function isOptionsEqual(optionsA, optionsB) {
      return isEqual(sortBy(optionsA, 'id'), sortBy(optionsB, 'id'));
    }
  }, {
    key: "getNextState",
    value: function getNextState(props, selectedId) {
      if (typeof selectedId !== 'undefined') {
        var option = props.options.find(function (_option) {
          return _option.id === selectedId;
        });

        if (option) {
          var value = props.valueParser(option) || '';
          return {
            value: value,
            selectedId: selectedId
          };
        }
      }

      return {
        value: '',
        selectedId: NO_SELECTED_ID
      };
    }
  }]);

  return Dropdown;
}(InputWithOptions);

Dropdown.propTypes = _objectSpread(_objectSpread({}, InputWithOptions.propTypes), {}, {
  /** THIS PROP WAS REMOVED */
  withArrow: PropTypes.bool,

  /** Sets the selected option id. (Implies Controlled mode) */
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** An initial selected option id. (Implies Uncontrolled mode) */
  initialSelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
extendPropTypes(Dropdown, {
  selectedId: allValidators(PropTypes.oneOfType([PropTypes.string, PropTypes.number]), function (props, propName) {
    if (props[propName] !== undefined && props['initialSelectedId'] !== undefined) {
      return new Error("'selectedId' and 'initialSelectedId' cannot both be used at the same time.");
    }
  })
});
Dropdown.defaultProps = InputWithOptions.defaultProps;
Dropdown.displayName = 'Dropdown';
export default Dropdown;